export const api_url = "https://albanyproducts.eu/api";
export const ws_url = "wss://albanyproducts.eu/api/ws";